import './query.less';
import React from 'react';
import * as R from 'ramda';
import ReactJSONView from 'react-json-view';
import _ from 'lodash';
import { Tooltip, Popover, Drawer, Timeline, Avatar, Tabs, Select, Input, Button, Layout, Menu, Icon, Row, Col, Table, Divider } from 'antd';
import { PLAYER_URL, MEDIA_API_URL } from '../../common/api/config';

const standardColumnWidth = 'auto';

class QueryResultsTable extends React.Component {
  constructor(props) {
    super(props);

    this.columns = {
      'mediaId': {
        key: 'mediaId',
        dataIndex: 'mediaId',
        title: 'mediaId',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.mediaId.localeCompare(b.mediaId),
      },
      'accountId': {
        key: 'accountId',
        dataIndex: 'accountId',
        title: 'accountId',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.accountId.localeCompare(b.accountId),
      },
      'externalId': {
        key: 'externalId',
        dataIndex: 'externalId',
        title: 'externalId',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.externalId.localeCompare(b.externalId),
      },
      'mediaContentType': {
        key: 'mediaContentType',
        dataIndex: 'mediaContentType',
        title: 'mediaContentType',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.mediaContentType.localeCompare(b.mediaContentType),
      },
      'length': {
        key: 'length',
        dataIndex: 'length',
        title: 'length',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.length - b.length,
      },
      'dateCreated': {
        key: 'dateCreated',
        dataIndex: 'dateCreated',
        title: 'dateCreated',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.dateCreated.localeCompare(b.dateCreated),
      },
      'dateFinished': {
        key: 'dateFinished',
        dataIndex: 'dateFinished',
        title: 'dateFinished',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.dateFinished.localeCompare(b.dateFinished),
      },
      'totalSilenceRatio': {
        key: 'totalSilenceRatio',
        dataIndex: 'totalSilenceRatio',
        title: 'totalSilenceRatio',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.totalSilenceRatio - b.totalSilenceRatio,
      },
      'unattributedSilenceRatio': {
        key: 'unattributedSilenceRatio',
        dataIndex: 'unattributedSilenceRatio',
        title: 'unattributedSilenceRatio',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.unattributedSilenceRatio - b.unattributedSilenceRatio,
      },
      'transitions': {
        key: 'transitions',
        dataIndex: 'transitions',
        title: 'transitions',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.transitions - b.transitions,
      },
      'wordCount': {
        key: 'wordCount',
        dataIndex: 'wordCount',
        title: 'wordCount',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.wordCount - b.wordCount,
      },
      'confidence': {
        key: 'confidence',
        dataIndex: 'confidence',
        title: 'confidence',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.confidence - b.confidence,
      },
      'metadata': {
        key: 'metadata',
        dataIndex: 'metadata',
        title: 'metadata',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.metadata.localeCompare(b.metadata),
      },
      'classifiers': {
        key: 'classifiers',
        dataIndex: 'classifiers',
        title: 'classifiers',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.classifiers.localeCompare(b.classifiers),
      },
      'keywords': {
        key: 'keywords',
        dataIndex: 'keywords',
        title: 'keywords',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.keywords.localeCompare(b.keywords),
      },
      'topics': {
        key: 'topics',
        dataIndex: 'topics',
        title: 'topics',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.topics.localeCompare(b.topics),
      },
      'detectors': {
        key: 'detectors',
        dataIndex: 'detectors',
        title: 'detectors',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.detectors.localeCompare(b.detectors),
      },
      'title': {
        key: 'title',
        dataIndex: 'title',
        title: 'title',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.title.localeCompare(b.title),
      },
      'description': {
        key: 'description',
        dataIndex: 'description',
        title: 'description',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.description.localeCompare(b.description),
      },
      'formatVersion': {
        key: 'formatVersion',
        dataIndex: 'formatVersion',
        title: 'formatVersion',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.formatVersion.localeCompare(b.formatVersion),
      },
      'published': {
        key: 'published',
        dataIndex: 'published',
        title: 'published',
        width: standardColumnWidth,
        render: this.renderCell,
        sorter: (a, b) => a.published.localeCompare(b.published),
      },
      '__generic': {
        key: '',
        title: '',
        width: standardColumnWidth,
        dataIndex: '',
        render: this.renderCell,
      },
      '__play': {
        key: 'play',
        title: 'Play',
        width: 80,
        dataIndex: 'mediaId',
        align: 'center',
        render: (value, record, index) => {
          return (
            <Button
              shape="circle"
              size="small"
              icon="play-circle"
              disabled={!value}
              data-index={index}
              data-media={value}
              data-hits={record._hits}
              onClick={this.handleShowPlayer}
            />
          );
        },
      },
      '__playEmpty': {
        key: 'play',
        title: (
          <span>
            <Tooltip placement="right" title="Include a mediaId in your query to listen to media.">
              <Icon style={{ color: '#faad14' }} type="exclamation-circle" /> Play
            </Tooltip>
          </span>
        ),
        width: 80,
        dataIndex: 'mediaId',
        align: 'center',
        render: value => (
          <Button
            shape="circle"
            size="small"
            icon="play-circle"
            disabled={!value}
            data-media={value}
            onClick={this.handleShowPlayer}
          />
        ),
      },
    };
  }

  state = {
    drawerVisible: false,
    drawerContents: null,
    drawerWidth: 0,
  };

  shouldComponentUpdate(nextProps, nextState) {
    return (
      Object.keys(nextProps).some(key => this.props[key] !== nextProps[key]) ||
      Object.keys(nextState).some(key => this.state[key] !== nextState[key])
    );
  }

  getColumnDefinitions = R.memoize((columns) => {
    const columnSet = columns.map(c => (
      this.columns[c] || {
        ...this.columns.__generic,
        title: c,
        key: c,
        dataIndex: c,
      }
    ));

    if (columnSet.length) {
      columnSet.unshift(columns.indexOf('mediaId') >= 0 ? this.columns.__play : this.columns.__playEmpty);
    }

    return columnSet;
  });

  columns = {};

  handleShowPlayer = (event) => {
    const { connection, id } = this.props;
    const { media, hits, index } = event.target.dataset;
    let parsedHits = [],
        externalHits = {},
        selectedRow = this.props.data.filter(row => row.mediaId === media)[0];

    let hitsArray = [];

    if(selectedRow['hits()'] != undefined) {
      hitsArray = JSON.parse(selectedRow['hits()']);
    }

    if(hitsArray && hitsArray.length > 0) {
      externalHits.SectionTitle = "Query Results";
      externalHits.groupTitle = "Hits";
      externalHits.showSubItems = true;

      externalHits.hits = _(hitsArray).map(hit => {
        const start = _.get(hit, 'fieldValues.startMs', null);
        const end = _.get(hit, 'fieldValues.endMs', null);
        const label = _.get(hit, 'conditions', []);
        if (start === null || end === null) return null;
        return {
          s: [start],
          e: [end],
          label: Array.isArray(label)? label.join('') : ''
        };
      }).compact(_.identity).value();
    }
    if (hits) {
      console.log('####### hits: ',hits);
      try {
        parsedHits = JSON.parse(hits)
          .map((hit) => {
            if (hit.fieldValues && hit.fieldValues.turns) {
              return {
                startTime: hit.fieldValues.turns.startMs,
                endTime: hit.fieldValues.turns.startMs + 1000,
              };
            }

            if (hit.fieldValues) {
              return {
                startTime: hit.fieldValues.startMs,
                endTime: hit.fieldValues.startMs + 1000,
              };
            }

            return undefined;
          })
          .filter(hit => hit);
      } catch (e) {
        console.log(e);
      }
    }

    const playerConfig = {
      searchTimeRanges: JSON.stringify(parsedHits),
      analyticsFormat: 'ANALYTICS_SCHEMA_VERSION_V3',
      mediaId: media,
      height: true,
      token: connection.bearerToken,
      apiUrl: MEDIA_API_URL,
    };
    if(hitsArray && hitsArray.length > 0) {
      playerConfig.externalHits = JSON.stringify(externalHits);
    }

    const urlParams = Object.entries(playerConfig).map(pair => pair.join('=')).join('&');
    const computedURL = `${PLAYER_URL}?index=${id}/${media}/${index}#${urlParams}`;

    this.setState({
      drawerVisible: true,
      drawerContents: (
        <iframe
          title="Player"
          style={{ border: 'none', width: '100%', height: '100%' }}
          src={computedURL}
        />
      ),
      drawerWidth: '600px',
    });
  };

  handleShowJSON = (event) => {
    const json = JSON.parse(event.target.dataset.json);
    this.setState({
      drawerVisible: true,
      drawerContents: (
        <div style={{ overflowX: 'scroll', padding: '24px' }}>
          <ReactJSONView displayDataTypes={false} name={false} theme="rjv-default" src={json} />
        </div>
      ),
      drawerWidth: 600,
    });
  };

  handleShowList = (event) => {
    this.setState({
      drawerVisible: true,
      contents: (<div style={{ padding: '24px' }}>{value}</div>),
      drawerWidth: 300,
    });
  };

  handleDrawerClose = () => {
    this.setState({
      drawerVisible: false,
    });
  };

  renderCell = (value, record, index) => {
    try {
      const parsed = JSON.parse(value);
      switch (typeof parsed) {
        case 'object':
          if (parsed.length === 0 || !Object.keys(parsed).length) return (value);
          return (
            <Button
              size="small"
              data-json={value}
              onClick={this.handleShowJSON}
              icon="ellipsis"
            />
          );
        case 'number':
        case 'string':
        default:
      }
    } catch (e) { /* empty statement */ }
    return (value);
  };

  render() {
    const { meta, columns, data, isLoading } = this.props;
    const columnDefinitions = this.getColumnDefinitions(columns);
    return (
      <div>
        <Row
          type="flex"
          justify="space-between"
          align="middle"
          style={{
            background: '#fff',
            padding: '16px',
            border: '1px solid #d9d9d9',
            borderTop: 'none',
            borderBottom: 'none',
          }}
        >
          <Col>
            {/*<Input.Search style={{ width: 200 }} />*/}
          </Col>
          <Col>
            Received {data.length} of {meta.totalResults} matched results in {meta.queryTimeMillis}ms.
          </Col>
        </Row>
        <div>
          <Table
            rowKey={record => record.mediaId}
            className="vb-query_table"
            bordered
            size="small"
            loading={isLoading}
            columns={columnDefinitions}
            dataSource={data}
            scroll={{ x: true }}
          />
        </div>
        <Drawer
          className="vb-drawer"
          placement="right"
          width={this.state.drawerWidth}
          closable={false}
          visible={this.state.drawerVisible}
          maskClosable={true}
          onClose={this.handleDrawerClose}
          style={{ padding: '0' }}
        >
          {this.state.drawerContents}
        </Drawer>
      </div>
    );
  }
}

export default QueryResultsTable;
